export const numberMask = (value?: string) => {
  if (!value) return ''

  let v = value.replace(/[^\d.,]/g, '')

  v = v.replace(/\./g, ',')
  const parts = v.split(',')

  if (parts.length > 2) {
    v = parts.shift()! + ',' + parts.join('')
  }

  let [int, dec] = v.split(',')

  int = int.replace(/^0+(?=\d)/, '')

  if (dec) {
    dec = dec.slice(0, 2)
  }

  int = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

  return dec !== undefined ? `${int},${dec}` : int
}
